import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";
import { RequestModel } from "@/api/Requests";

export type RequestDetailsRequest = {
  requestId: string;
  date: Date;
};

export type RequestDetailsResponse = {
  request: RequestModel;
};

export const requestDetails = async (request: RequestDetailsRequest) => {
  const response = await executeApiRequest(
    () => axios.get<RequestDetailsResponse>("/requests/details", { params: request }),
    false
  );

  return response?.data;
};
